import React, { createContext, useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Nav from 'react-bootstrap/Nav';
import ModalEditFormulario from './ModalEditFormulario';
import MsgUtils from '../Tools/MsgUtils';
import UtilsBufer from '../Tools/UtilsBufer';
import DateConverter from '../Tools/DateConverter';
import ContenidoFormulario from './ContenidoFormulario';
import ModalCargando from '../utilsComponentes/ModalCargando';
import RespuestasFormulario from './RespuestasFormulario';
import ListaColaboradorLink from './ListaColaboradorLink';
export const contextFormulario = createContext();
const server = process.env.REACT_APP_SERVER;

function PrincipalFormulario(props) {
  const { tipo, callback } = props;
  const [encuestas, setEncuestas] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [tituloModal, setTituloModal] = useState('');
  const [ventana, setVentana] = useState(0);
  const [regional, setRegional] = useState('');
  const [selectItem, setSelectItem] = useState({});
  const [actualizar, setActualizar] = useState(false);
  const [loader, setLoader] = useState(true);
  const [filtroTipo, setFiltroTipo] = useState(tipo == null ? 'N' : 'E');
  const [soloVer, setSoloVer] = useState(false);
  const [selectRespuesta, setSelectRespuesta] = useState(null);
  const [verRespuesta, setVerRespuesta] = useState(false);
  const [encuestaElegida, setEncuestaElegida] = useState(null);
  const [createCopy, setCreateCopy] = useState(false);
  const [ventanaModal, setVentanaModal] = useState(0);
  const [verTodo, setVerTodo] = useState(0);
  const [idUsuario, setIdUsuario] = useState(null);
  const editarItem = (dato, tipo) => {
    if (['A', 'R'].indexOf(dato.ESTADO) == -1) {
      setSoloVer(true);
    } else {
      setSoloVer(false);
    }
    setCreateCopy(tipo);
    setTituloModal('E');
    setSelectItem(dato);
    setModalShow(true);
  }
  const editarContenido = (dato) => {
    setSelectItem(dato);
    setVentana(1);
  }
  function eliminarEncuesta() {
    fetch(`${server}/formulario/deleteFormulario`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional, ...selectItem
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          MsgUtils.msgCorrecto(data.ok);
          setActualizar(!actualizar);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => MsgUtils.msgError(err));
  }
  function validarInactivarFormulario(dato, estado) {
    fetch(`${server}/formulario/validarInactivarFormulario`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional, ...dato, "ESTADO_NUEVO": estado
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          MsgUtils.msgCorrecto(data.ok);
          setActualizar(!actualizar);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => MsgUtils.msgError(err));
  }
  function validarEstado(dato, tipo) {
    var text = '', css = '', border = '';
    if (dato.ESTADO === 'A') {
      text = "PUBLICADO"
      css = 'colorVerde'
      border = 'bordeVerde'
    } else if (dato.ESTADO === 'P') {
      text = 'PENDIENTE'
      css = 'colorAmarillo'
      border = 'bordeAmarillo'
    } else if (dato.ESTADO === 'R') {
      text = 'INACTIVO'
      css = 'colorRojo'
      border = 'bordeRojo'
    }
    if (tipo === 0) {
      return (
        <span className={`${css}`}>
          <i className="fa-solid fa-bookmark"></i> {text}
        </span>
      )
    } else {
      return border
    }
  }
  function validarPermiso(permiso) {
    var userPermiso = (JSON.parse(localStorage.getItem('info')).PERMISO).split(':');
    if (userPermiso.indexOf(permiso) >= 0 || userPermiso.indexOf('0') >= 0) {
      return true;
    } else {
      return false;
    }
  }
  function validarPermisoFormulario(dato) {
    if (validarPermiso('24')) {
      if (validarPermiso('25')) {
        if (filtroTipo == 'N') {
          return dato.TIPO == filtroTipo;
        } else {
          return dato.TIPO !== 'N';
        }
      } else {
        if (filtroTipo == 'N') {
          return dato.ESTADO == 'A' && dato.TIPO == filtroTipo
        } else {
          return dato.ESTADO == 'A' && dato.TIPO !== 'N'
        }
      }
    } else {
      if (filtroTipo == 'N') {
        return dato.TIPO == filtroTipo;
      } else {
        return dato.TIPO !== 'N';
      }
    }
  }
  function obtenerFormularios(reg) {
    fetch(`${server}/formulario/getFormularios`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        regional: reg, tipo: 0
      })
    })
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          console.log(data.ok);
          setEncuestas(data.ok);
        } else {
          MsgUtils.msgError(data.error);
        }
        setLoader(false);
      })
      .catch(err => MsgUtils.msgError(err));
  }
  function verRespuestas(dato) {
    setSelectItem(dato);
    setVentana(2);
    setSoloVer(true);
  }
  function validarSeleccionEncuesta(dato) {
    if (encuestaElegida == null) {
      return 'bg-dark'
    } else {
      if (dato.ID_ENCUESTA == encuestaElegida.ID_ENCUESTA) {
        return 'bg-secondary'
      } else {
        return 'bg-dark'
      }
    }
  }
  useEffect(() => {
    setLoader(true);
    var reg = JSON.parse(localStorage.getItem('info'));
    if (regional === '') {
      setIdUsuario(reg.ID_EMPLEADO)
      setRegional(reg.ID_REGIONAL_ACTUAL);
      obtenerFormularios(reg.ID_REGIONAL_ACTUAL);
    } else {
      obtenerFormularios(regional);
    }
  }, [actualizar])
  return (
    <contextFormulario.Provider value={{
      regional, ventana, setVentana, selectItem, actualizar, setActualizar, setModalShow,
      tituloModal, soloVer, setLoader, loader, selectRespuesta, setSelectRespuesta, verRespuesta, setVerRespuesta
    }}>
      <ModalCargando show={loader} />
      {ventana === 0 && loader === false &&
        <div>
          <div className='container-fluid bg-dark bg-gradient py-1'>
            <div className='row row-cols'>
              <div className='col-6'>

              </div>
              {(tipo == null || tipo == 'V') &&
                <div className='col-6 text-end'>
                  {validarPermiso('65') &&
                    <select className='form-select form-select-sm btn btn-light btn-sm mx-1' style={{ minWidth: '130px', maxWidth: '130px' }}
                      value={regional}
                      onChange={(e) => { setRegional(e.target.value); setEncuestas([]) }}>
                      <option value="990">Reg CBBA</option>
                      <option value="991">Reg SCRZ</option>
                    </select>}
                  {validarPermiso('67') &&
                    <select className='form-select form-select-sm btn btn-light btn-sm mx-1' style={{ minWidth: '130px', maxWidth: '130px' }}
                      value={verTodo}
                      onChange={(e) => { setVerTodo(e.target.value); }}>
                      <option value={0}>Los Mios</option>
                      <option value={1}>Todos</option>
                    </select>}
                  <button className='btn btn-sm btn-secondary mx-1' onClick={() => setActualizar(!actualizar)}>
                    <i className="fa-solid fa-repeat"></i> Recargar
                  </button>
                  {validarPermiso('25') &&
                    <button className='btn btn-success btn-sm' onClick={() => { setTituloModal('N'); setModalShow(true); }}>
                      <i className="fa-solid fa-circle-plus fa-xl"></i> Nuevo
                    </button>}
                </div>}
            </div>
          </div>
          <div className='bg-dark bg-gradient'>
            <Nav fill variant="tabs" onSelect={(e) => setFiltroTipo(e)} activeKey={filtroTipo} >
              <Nav.Item bsPrefix='nav-item navItemBorder'>
                <Nav.Link eventKey={'N'} bsPrefix={`nav-link ${filtroTipo == 'N' ? 'text-dark' : 'text-light'}`}>Encuestas</Nav.Link>
              </Nav.Item>
              <Nav.Item bsPrefix='nav-item navItemBorder'>
                <Nav.Link eventKey={'E'} bsPrefix={`nav-link ${filtroTipo == 'E' ? 'text-dark' : 'text-light'}`}>Examenes</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
          <div className='table-responsive'>
            <table className='table table-dark table-sm table-striped table-hover table-bordered border-secondary'>
              <thead>
                <tr>
                  <th style={{ width: '30px' }}>#</th>
                  <th style={{ width: '300px' }}>Titulo</th>
                  <th style={{ width: '190px' }}>Tipo</th>
                  <th style={{ width: '140px' }}>Obligatorio</th>
                  <th style={{ width: '90px' }}>Respuestas</th>
                  <th style={{ width: '190px' }}>Contenido</th>
                  <th style={{ width: '130px' }}>Estado</th>
                  <th style={{ width: '50px' }}></th>
                  <th style={{ width: '50px' }}></th>
                </tr>
              </thead>
              <tbody>
                {encuestas.map((item, index) => {
                  if (validarPermisoFormulario(item)) {
                    if ((verTodo==0&&item.CREADO_POR==idUsuario)||(verTodo==1)) {
                      return (
                        <tr key={index}>
                          <th>{item.ID_ENCUESTA}</th>
                          <td>
                            <div className='lh-1'>{item.TITULO}</div>
                            <div className={`badge w-100 lh-1`}>{validarEstado(item, 0)}</div>
                          </td>
                          <td style={{ fontSize: '12px' }}>{item.TIPO_ENCUESTA}</td>
                          <td>{item.ES_OBLIGADO}</td>
                          <td className='text-center'><span className={`badge bg-light text-dark`}>{item.NUM_RESPUESTA}</span></td>
                          <td>
                            <div className='btn-group btn-group-sm w-100'>
                              <button className='btn btn-sm w-100 btn-warning m-0 p-0 '
                                title='Ver contenido de la encuesta'
                                onClick={() => { editarContenido(item); setSoloVer(true); }}>
                                <i className="fa-solid fa-eye fa-xl"></i> Ver
                              </button>
                              {item.ESTADO !== 'A' && item.ESTADO !== 'R' &&
                                <button className='btn btn-sm w-100 btn-light m-0 p-0'
                                  onClick={() => { editarContenido(item); setSoloVer(false); }}>
                                  <i className="fa-solid fa-file-pen"></i> Editar
                                </button>}
                            </div>
                          </td>
                          <td>
                            <div className="">
                              <select className="form-select form-select-sm" value={item.ESTADO}
                                onChange={(e) => validarInactivarFormulario(item, e.target.value)}>
                                <option value="P">PENDIENTE</option>
                                <option value="A">PUBLICADO</option>
                                <option value="R">INACTIVO</option>
                              </select>
                            </div>
                          </td>
                          <td>
                            {item.ESTADO !== 'A' && <button className='btn btn-sm btn-transparent text-danger' onClick={() => setSelectItem(item)}
                              title='Eliminar Formulario'
                              data-bs-toggle="modal" data-bs-target="#EliminarModal">
                              <i className="fa-solid fa-trash-can fa-2xl"></i>
                            </button>}
                            {item.ESTADO === 'A' && <button className='btn btn-sm btn-transparent text-danger'
                              title='Desactivar Formulario Publicado'
                              onClick={() => { validarInactivarFormulario(item, 'R') }}>
                              <i className="fa-solid fa-bug-slash fa-2xl"></i></button>}
                          </td>
                          <td>
                            <button className='btn btn-sm btn-transparent text-light'
                              title='Ver detalle del formulario' onClick={() => { setVentanaModal(0); editarItem(item, false) }}>
                              <i className="fa-solid fa-ellipsis fa-2xl"></i>
                            </button>
                          </td>
                        </tr>
                      )
                    }
                  }
                })}
              </tbody>
            </table>
          </div>
        </div>}
      {ventana === 1 &&
        <ContenidoFormulario selectItem={selectItem} setVentana={setVentana} regional={regional} soloVer={soloVer}
          setLoader={setLoader} selectRespuesta={selectRespuesta} setSelectRespuesta={setSelectRespuesta}
          setVerRespuesta={setVerRespuesta} />
      }
      <Modal show={modalShow} onHide={() => { setActualizar(!actualizar); setModalShow(false) }}
        size="xl" backdrop="static"
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
        contentClassName='bg-dark bg-gradient w-100' centered>
        <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
          <Modal.Title>
            {tituloModal === 'N' && <div className='text-light'> Nuevo Formulario</div>}
            {tituloModal !== 'N' &&
              <div className='text-light'>{selectItem.TIPO_ENCUESTA} - {validarEstado(selectItem, 0)}</div>
            }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body bsPrefix='modal-body m-0 p-0' style={{ minHeight: `${window.innerHeight - window.innerHeight * 0.2}px` }}>
          {tituloModal == 'N' && <ModalEditFormulario createCopy={createCopy} soloVer={true} />}
          {tituloModal !== 'N' && <>
            <Nav fill variant="tabs" onSelect={(e) => setVentanaModal(e)} activeKey={ventanaModal}>
              <Nav.Item bsPrefix='nav-item navItemBorder'>
                <Nav.Link eventKey={0} bsPrefix={`nav-link ${ventanaModal == 0 ? 'text-dark' : 'text-light'}`}>Editar</Nav.Link>
              </Nav.Item>
              <Nav.Item bsPrefix='nav-item navItemBorder'>
                <Nav.Link eventKey={1} bsPrefix={`nav-link ${ventanaModal == 1 ? 'text-dark' : 'text-light'}`}>Ver Respuestas</Nav.Link>
              </Nav.Item>
              <Nav.Item bsPrefix='nav-item navItemBorder'>
                <Nav.Link eventKey={2} bsPrefix={`nav-link ${ventanaModal == 2 ? 'text-dark' : 'text-light'}`}>Generar Link</Nav.Link>
              </Nav.Item>
              <Nav.Item bsPrefix='nav-item navItemBorder'>
                <Nav.Link eventKey={3} bsPrefix={`nav-link ${ventanaModal == 3 ? 'text-dark' : 'text-light'}`}>Link General</Nav.Link>
              </Nav.Item>
            </Nav>
            {ventanaModal == 0 && <ModalEditFormulario createCopy={createCopy} soloVer={soloVer} />}
            {ventanaModal == 1 && <div className='overflow-auto'><RespuestasFormulario /></div>}
            {ventanaModal == 2 && <div className='overflow-auto'><ListaColaboradorLink encuesta={selectItem} regional={regional} /></div>}
            {ventanaModal == 3 && <div className='overflow-auto'>
              <textarea className='form-control text-center'
                value={`${server}/EncuestaGeneral/${selectItem.ID_ENCUESTA}/${regional}`} />
            </div>}
          </>}
        </Modal.Body>
      </Modal>
      <div className="modal fade" id="EliminarModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content bg-warning">
            <div className="modal-header m-0 p-0 mx-2">
              <h5 className="modal-title" id="exampleModalLabel">Eliminar Ecuesta</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className='text-dark fs-1'>
                <i className="fa-solid fa-triangle-exclamation fa-fade"></i> Esta seguro de Eliminar!!!
              </div>
            </div>
            <div className="modal-footer m-0 p-0 mx-2">
              <button type="button" className="btn btn-sm btn-secondary"
                data-bs-dismiss="modal"><i className="fa-solid fa-thumbs-down"></i> NO</button>
              <button type="button" className="btn btn-sm btn-primary"
                data-bs-dismiss="modal" onClick={() => eliminarEncuesta()}>
                <i className="fa-solid fa-thumbs-up"></i> SI
              </button>
            </div>
          </div>
        </div>
      </div>
    </contextFormulario.Provider>
  )
}

export default PrincipalFormulario
